<template><SimpleModuleDashboard :module-id="Modules.NOTIFICACIONES" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'inbox', reference: 'inbox', route: 'NotificationsStaffInbox', tone: 'primary' },
  { id: 'configuration', reference: 'configuration', route: 'NotificationsStaffConfigurations', tone: 'primary', group: 'Configuraciones' },
  { id: 'manualSend', reference: 'manualSend', route: 'NotificationsStaffManualSend', tone: 'primary', group: 'Configuraciones' },
  { id: 'eventTypes', reference: 'eventTypes', route: 'NotificationsStaffEventTypes', tone: 'primary' },
  { id: 'log', reference: 'log', route: 'NotificationsStaffLog', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
